import { render } from "./ProcedenciaList.vue?vue&type=template&id=2352757b&scoped=true"
import script from "./ProcedenciaList.vue?vue&type=script&lang=js"
export * from "./ProcedenciaList.vue?vue&type=script&lang=js"

import "./ProcedenciaList.vue?vue&type=style&index=0&id=2352757b&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_restaurante\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2352757b"]])

export default __exports__